<template>
    <!--        <div style="float: right;">-->
    <!--            <div class="table-toolbar">-->
    <!--                <a-button type="primary" @click="onEdit">编辑资料-->
    <!--                    <template #icon>-->
    <!--                        <form-outlined/>-->
    <!--                    </template>-->
    <!--                </a-button>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="top">
        <div class="imgBox">
            <a-image v-if="detail.headShot" width="74" height="103" :src="getImg(detail.headShot)"/>
            <img v-else style="width: 100%;height: 100%;"
                 src="@/assets/home/user-zj-avatar.png"/>

        </div>
        <div class="rightBox" style="display: flex;height: 100px;">
            <div style="width: 80%;margin-top: 20px">
                <div class="topBox">
                    <p class="name">{{ detail.name }}
                        <img v-if="detail.appointmentFlag==='1'" :src="zjkcy" alt="" style="margin-bottom: 6px;"/>
                    </p>
                    <!--                        <div class="user-type">专家用户</div>-->
                </div>
                <a-divider dashed/>
                <div class="second">
                    <!--                        <div style="margin-right: 50px"><span style="font-size: 14px;color: rgb(172, 172, 172)">注册用户：</span>专家用户</div>-->
                    <div>
                        <span style="font-size: 14px;color: #333333;">
                            <SolutionOutlined />
                            {{detail.groupName}}
                        </span>
                        <a-divider type="vertical"/>
                        <span style="font-size: 14px;color: #333333;">
                            <PhoneOutlined/>
                            {{ detail.phoneNumber }}
                        </span>
                        <a-divider type="vertical"  v-if="detail.appointmentFlag==='1'"/>
                        <span style="font-size: 14px;color: #333333;" v-if="detail.appointmentFlag==='1'">
                            <HourglassOutlined />
                            聘书将于 <span style="color: orange">{{ moment(detail.appointmentTime).add(1, 'y').format("YYYY-M-D") }}</span> 到期
                        </span>
                    </div>
                </div>

            </div>
            <div style="margin-right: 20px">
                <img v-if="detail.auditState==='1' && detail.appointmentFlag==='1'" :src="rzcg" alt="">
                <img v-else-if="detail.auditState==='1' && detail.appointmentFlag==='0'" :src="ysh" alt="">
                <img v-else-if="detail.auditState==='0'" :src="dsh" alt="">
                <img v-else :src="wrz" alt="">
            </div>
        </div>
    </div>

    <div class="info-content">
        <div class="title">
            <div class="tit">个人信息</div>
            <div class="btn" @click="onEdit">
                <img src="../../../../assets/home/user-icon-01.png" alt="">
                编辑
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div class="item">
                    <div class="name">聘用证书：</div>
                    <div class="value" v-if="detail.appointmentFile">
                        <ImgUpload ref="upload" modalWidth="850px" modalTitle="聘书预览"
                                   v-model:value="detail.appointmentFile" :disabled="true"
                                   :show-btn="false"></ImgUpload>
                    </div>
                    <div class="value"
                         style="width: 104px;height: 104px;color:#666;background: #fafafa;border: 1px dashed #d9d9d9;border-radius: 4px;text-align: center;line-height: 104px;"
                         v-else>
                        暂无
                    </div>
                </div>
                <div class="item">
                    <div class="name">聘书发放时间：</div>
                    <div class="value" v-if="detail.appointmentTime">
                        {{ detail.appointmentTime.substr(0, 10) }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">工作单位：</div>
                    <div class="value">
                        {{ detail.workUnit }}
                    </div>
                </div>
            </div>
            <div class="middle">
                <div class="item">
                    <div class="name">身份证号码：</div>
                    <div class="value">
                        {{ detail.idCard }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">职称：</div>
                    <div class="value">
                        {{ detail.positional }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">身份证：</div>
                    <div class="value">
                        <a href="#" @click="onPreviewFile(detail.idCardFile)">
                            <img :src="sfz" alt=""><span style="margin-left: 8px">身份证</span></a>
                        <!--                           <FileUpload :show-btn="false" v-model:value=" detail.idCardFile " disabled></FileUpload>-->
                    </div>
                </div>
                <div class="item">
                    <div class="name">专家库成员申请表：</div>
                    <div class="value">
                        <a href="#" @click="onPreviewFile(detail.applyFile)"><img :src="sqb" alt=""><span
                            style="margin-left: 8px">专家库成员申请表</span></a>
                        <!--                           <FileUpload :show-btn="false" v-model:value=" detail.applyFile " disabled></FileUpload>-->
                    </div>
                </div>
                <div class="item">
                    <div class="name">职称证书：</div>
                    <div class="value">
                        <a href="#" @click="onPreviewFile(detail.positionalFile)"><img width="16" :src="zczs"
                                                                                       alt=""><span
                            style="margin-left: 8px">职称证书</span></a>
                        <!--                           <FileUpload :show-btn="false" v-model:value=" detail.positionalFile " disabled></FileUpload>-->
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="item">
                    <div class="name">银行账号：</div>
                    <div class="value">
                        {{ detail.bankAccount }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">银行名称：</div>
                    <div class="value">
                        {{ detail.bankName }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">行号：</div>
                    <div class="value">
                        {{ detail.bankNo }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">个人签名：</div>
                    <div class="value">
                        <ImgUpload v-if="detail.signatureFile" v-model:value="detail.signatureFile" disabled :count="1"
                                   modal-title="签名预览"></ImgUpload>
                        <div v-else>未上传</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getExpertInfo"/>
    <a-modal :visible="visible" centered :title="null" :closable="false" @cancel="visible=false">

        <a-alert message="未认证"
                 description="请您尽快完善资料，并提交审核！"
                 show-icon
                 type="warning" />
        <template #footer>
            <a-button key="back" @click="visible=false">稍后</a-button>
            <a-button key="submit" type="primary" @click="toAudit">去认证</a-button>
        </template>
    </a-modal>

    <a-modal :visible="visible2" centered :title="null" :closable="false" @cancel="visible2=false">
<!--        <template #title>-->
<!--            <ExclamationCircleOutlined style="color: #ffa39e"/><span style="margin-left: 10px;">提示</span>-->
<!--        </template>-->
        <a-alert message="审核未通过"
                 :description="detail.denyReason"
                 show-icon
                 type="error" />
        <template #footer>
            <a-button key="back" @click="visible2=false">稍后</a-button>
            <a-button key="submit" type="primary" @click="toAudit">去认证</a-button>
        </template>
    </a-modal>
</template>

<script>
import {file_service} from "@/api/adminService";

import {expert} from "@/api/projectReviewService";
import UserModal from "@/views/sys/expert/expertInfo/components/UserModal";
// import ImgUpload from "@/components/form/upload/ImgUpload";
import moment from "moment";
import ImgUpload from "@/components/form/upload/ImgUpload";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";


const zjkcy = require('@/assets/img/zjkcy.png')
const rzcg = require('@/assets/img/rztg.png')

const ysh = require('@/assets/img/expert-state/已审核.png')
const dsh = require('@/assets/img/expert-state/待审核.png')
const wrz = require('@/assets/img/expert-state/未认证.png')

const sfz = require('@/assets/home/user-icon-02.png')
const sqb = require('@/assets/home/user-icon-03.png')
const zczs = require('@/assets/home/user-icon-04.png')

export default {
    name: "index",
    components: {ImgUpload, UserModal, ExclamationCircleOutlined},
    data() {
        return {
            moment,
            zjkcy,
            rzcg,
            sfz,
            sqb,
            zczs,
            ysh,
            dsh,
            wrz,
            detail: {},
            listKeyField: "id",
            visible:false,
            visible2: false
        }
    },
    mounted() {
        this.getExpertInfo()
    },
    watch:{
        detail(n){
            if (n){
                this.visible = this.detail.auditState==='-1'
                this.visible2 = this.detail.auditState==='2'
            }
        }
    },
    methods: {
        toAudit(){
            this.$router.push('/sys/expertAudit')
        },
        getExpertInfo() {
            this.getAction({
                url: expert.current
            }).then(res => {
                this.detail = {...res}
            })
        },
        onEdit() {
            this.onShowModal('userModal', this.detail);
        },
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        onPreviewFile(file) {
            /*axios({
                methods: 'get',
                url: file_service.download + file.split(',')[0],
                responseType: 'blob',
                headers: {
                    Authorization: 'Bearer ' + ls.get('token') || ''
                }
            }).then(() => {
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + file;
                link.target = '_blank';
                link.click();
            })*/
            const split = file?.split(",");
            for (const s of split) {
                console.log(s)
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + s;
                link.target = '_blank';
                link.click();
            }
        }
    }
}
</script>

<style scoped lang="less">
.info-content {
    background: #fff;
    height:100%;
    .content {
        padding: 20px 30px 30px 30px;
        display: flex;
        justify-content: space-between;

        .left, .middle, .right {
            width: 30%;
        }

        .left, .middle {
            border-right: 1px solid #F5F5F5;
        }

        .item {
            margin: 0 0 20px 0;

            .name {
                font-size: 14px;
                color: #999999;
                margin-bottom: 6px;
            }

            .value {
                font-size: 14px;
                color: #333333;

                a {
                    color: #0059B5;
                }

                img {
                    width: 16px;
                }
            }
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        border-bottom: 1px solid #DEDEDE;

        .btn {
            color: #999999;
            font-size: 14px;
            cursor: pointer;

            img {
                width: 15px;
                height: 15px;
                margin-bottom: 3px;
            }
        }

        .tit {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            padding-left: 10px;
            position: relative;

            &::before {
                content: '';
                display: block;
                width: 4px;
                height: 14px;
                background: #0059B5;
                border-radius: 2px;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }
    }
}

.top {
    margin-bottom: 20px;
    display: flex;
    background: #fff;
    padding: 30px;

    .imgBox {
        float: left;
        margin-right: 20px;
        width: 74px;
        height: 103px;
    }

    .rightBox {
        color: #333;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .topBox {
            //overflow: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .name {
                float: left;
                font-weight: 700;
                font-size: 22px;
            }

            .user-type {
                background: url("../../../../assets/home/user-type.png");
                background-size: 100% 100%;
                width: 100px;
                height: 30px;
                text-align: center;
                color: #fff;
                line-height: 30px;
                padding-left: 18px;
                margin-left: 8px;
            }

            .nameRight {
                float: left;
                margin-left: 25px;
                margin-top: 10px;
            }
        }

        .second {
            font-size: 16px;
            margin-top: 10px;
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            align-items: center;

            .name {
                width: 50%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }
        }
    }
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item) {
    margin: 0;
    padding: 0;
    width: 200px;
    height: auto;
    border: 0;
    border-radius: 0;
}

:deep(.ant-upload-list-picture-card-container) {
    margin: 0;
    width: 150px;
    height: auto;
}
:deep(.ant-divider-horizontal){
    margin: 5px 0;
}
:deep(.ant-divider-dashed){
    border-width: 2px 0 0;
}
:deep(.ant-divider-vertical){
    border-left: 2px solid rgba(0, 0, 0, 0.06);
}
:deep(.ant-image-img){
    width: 77px;
    height: 103px;
}
</style>
